import Grid from "../grid/Grid";
import GridTile from "../grid/GridTile";

export default class CharacterTarget {
    constructor() {
        /**
         * The target path destination.
         * @type {GridTile}
         */
        this.targetTile = null;

        /**
         * The target tile to mine.
         * @type {GridTile}
         */
        this.mineTile = null;

        /**
         * This is true when the character has a target, but is mid-tile and cannot have their target reset at this moment.
         * @type {boolean}
         */
        this.invalidated = false;

        /**
         * @type {string}
         */
        this.behaviorId = null;
    }

    /**
     * @param {GridTile} targetTile 
     * @param {GridTile} mineTile
     * @param {string} behaviorId
     */
    setTargetTile(targetTile, mineTile, behaviorId) {
        this.resetTarget();
        this.targetTile = targetTile;
        this.mineTile = mineTile;
        this.invalidated = false;
        this.behaviorId = behaviorId;
    }

    /**
     * 
     * @param {Grid} grid 
     */
    onGridUnload(grid) {
        if (this.targetTile && this.targetTile.grid === grid) {
            this.resetTarget();
            return;
        }

        if (this.mineTile && this.mineTile.grid === grid) {
            this.resetTarget();
        }
    }
    
    resetTarget() {
        this.targetTile = null;
        this.mineTile = null;
        this.invalidated = false;
        this.behaviorId = null;
    }
}